import React, { useState, useEffect } from 'react';

const StickerPreview = props => {
  const [sticker, setSticker] = useState();
  const [width, setWidth] = useState('auto');
  const [height, setHeight] = useState('auto');

  useEffect(() => {
    setSticker(props.item.sticker);
    //this checks to see if the sticker is new from the pack and thus will alter its dimensions accordingly
    if (props.item.sticker.pivot) {
      const elem = document.getElementById(`sticker-container-${props.item.sticker.id}`);
      setHeight(`${elem.offsetHeight}px`);
    }
  }, [props.item.sticker]);

  if (sticker) {
    return (
      <>
        <img
          src={sticker.url}
          width={width}
          height={height}
          alt="sticker-preview"
          style={{ transform: `rotate(${props.item.sticker.rotation}deg)` }}
        />
      </>
    );
  } else {
    return (
      <>
        <p>loading...</p>
      </>
    );
  }
};
export default StickerPreview;
